import { gql } from '@apollo/client';

export const GET_HELP_TUTORIALS = gql`
  query GetHelpTutorials {
    helpTutorials {
      id
      title
      content
      videoUrl
      visibleToRoles
      isPublic
      createdAt
    }
  }
`;

export const GET_HELP_TUTORIALS_FOR_USER = gql`
  query GetHelpTutorialsForUser {
    helpTutorialsForUser {
      id
      title
      content
      videoUrl
      visibleToRoles
      isPublic
      createdAt
    }
  }
`;

export const GET_HELP_TUTORIAL = gql`
  query GetHelpTutorial($id: Int!) {
    helpTutorial(id: $id) {
      id
      title
      content
      videoUrl
      visibleToRoles
      isPublic
      createdAt
    }
  }
`;

export const GET_HELP_TUTORIAL_FOR_USER = gql`
  query GetHelpTutorialForUser($id: Int!) {
    helpTutorialForUser(id: $id) {
      id
      title
      content
      videoUrl
      visibleToRoles
      isPublic
      createdAt
    }
  }
`;

export const GET_PUBLIC_HELP_TUTORIAL = gql`
  query GetPublicHelpTutorial($id: Int!) {
    publicHelpTutorial(id: $id) {
      id
      title
      content
      videoUrl
      visibleToRoles
      isPublic
      createdAt
    }
  }
`;

export const CREATE_HELP_TUTORIAL = gql`
  mutation CreateHelpTutorial($input: CreateHelpTutorialInput!) {
    createHelpTutorial(input: $input) {
      id
      title
      content
      videoUrl
      visibleToRoles
      isPublic
      createdAt
    }
  }
`;

export const UPDATE_HELP_TUTORIAL = gql`
  mutation UpdateHelpTutorial($id: Int!, $input: UpdateHelpTutorialInput!) {
    updateHelpTutorial(id: $id, input: $input) {
      id
      title
      content
      videoUrl
      visibleToRoles
      isPublic
      createdAt
    }
  }
`;

export const DELETE_HELP_TUTORIAL = gql`
  mutation DeleteHelpTutorial($id: Int!) {
    deleteHelpTutorial(id: $id)
  }
`; 